import { render, staticRenderFns } from "./UploadFileList.vue?vue&type=template&id=05b345e2&scoped=true&"
import script from "./UploadFileList.vue?vue&type=script&lang=js&"
export * from "./UploadFileList.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileList.vue?vue&type=style&index=0&id=05b345e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b345e2",
  null
  
)

export default component.exports